import { render, staticRenderFns } from "./ServiceTranslationNewPopup.vue?vue&type=template&id=6180cd10&"
import script from "./ServiceTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./ServiceTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports